import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceAppResource from "./WorkspaceAppResource";
import LuHubSourceAppResource from "./LuHubSourceAppResource";

class HubSourceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'hub-sources';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'hub/sources';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'hubUuid',
            'lookupHubSourceUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
            sourceType: LuHubSourceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'hub_uuid',
            sourceType: 'lookup_hub_source_uuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            hubUuid: {
                presence: true,
                type: 'string',
            },
            lookupHubSourceUuid: {
                presence: true,
                type: 'string',
            },
        };
    }
}

export default HubSourceAppResource;
